(() => {
function $ce6a18b12420bce7$export$7fd17f34fe72f4b0() {
    const loading = document.querySelector(".loading");
    if (!loading) return;
    const logo = loading.querySelector(".loading_logo");
    const logoPath = loading.querySelector(".loading_bg-svg path");
    gsap.set(logoPath, {
        drawSVG: "100% live"
    });
    gsap.set(logo, {
        opacity: 1,
        y: "0%"
    });
    gsap.set(loading, {
        clipPath: "inset(0% 0% 0% 0%)"
    });
    gsap.to(logoPath, {
        drawSVG: "0% live",
        duration: 2,
        delay: 0.5
    });
    gsap.to(logo, {
        opacity: 0,
        y: "-50%",
        delay: 0.5,
        duration: 1,
        ease: "expo.out"
    });
    gsap.to(loading, {
        clipPath: "inset(0% 0% 100% 0%)",
        duration: 1,
        delay: 1,
        ease: "expo.out",
        onComplete: ()=>{
            loading.style.display = "none";
            gsap.set(logo, {
                opacity: 0,
                y: "50%"
            });
            gsap.set(loading, {
                clipPath: "inset(100% 0% 0% 0%)"
            });
        }
    });
    // Loading animation
    const links = document.querySelectorAll("a");
    links.forEach((l)=>{
        l.addEventListener("click", (e)=>{
            // e.preventDefault();
            const href = l.href;
            const url = new URL(href);
            if (window.location.origin === url.origin && window.location.pathname !== url.pathname && l.target !== "_blank") {
                e.preventDefault();
                loading.style.display = "flex";
                gsap.to(logo, {
                    opacity: 1,
                    y: "0%",
                    duration: 1,
                    delay: 0.5,
                    ease: "expo.out"
                });
                gsap.to(logoPath, {
                    drawSVG: "100% live",
                    duration: 2,
                    delay: 0.5
                });
                gsap.to(loading, {
                    clipPath: "inset(0% 0% 0% 0%)",
                    duration: 1,
                    ease: "expo.out",
                    onComplete: ()=>{
                        window.location.href = href;
                    }
                });
            // setTimeout(() => {
            //   window.location.href = href;
            // }, 500);
            }
        });
    });
}


function $8dde7174b81b4982$export$1744cb1794fd120a() {
    // Register the Finsweet CMS load callback using the official API.
    window.fsAttributes = window.fsAttributes || [];
    window.fsAttributes.push([
        "cmsload",
        (listInstances)=>{
            console.log("cmsload Successfully loaded!");
            // Loop through all CMSList instances on the page.
            listInstances.forEach((listInstance)=>{
                // Listen for the 'renderitems' event.
                listInstance.on("renderitems", (renderedItems)=>{
                    $8dde7174b81b4982$var$setButtons();
                });
            });
        }
    ]);
    // Run the initial setup for buttons.
    $8dde7174b81b4982$var$setButtons();
}
function $8dde7174b81b4982$var$setButtons() {
    // Only select buttons that haven’t been initialized yet.
    const buttons = document.querySelectorAll(".button:not([data-initialized])");
    if (!buttons.length) {
        console.error("No new buttons found.");
        return;
    }
    // Initialize each new button.
    buttons.forEach((button)=>{
        button.setAttribute("data-initialized", "true");
        $8dde7174b81b4982$var$setButton(button);
    });
}
function $8dde7174b81b4982$var$setButton(button) {
    // Split the button text into spans for lines and words using SplitType.
    const buttonEls = new SplitType(button.querySelector(".button_label"), {
        types: "lines, words",
        tagName: "span"
    });
    const bg = button.querySelector(".button_bg");
    const icon = button.querySelectorAll(".button_icon-el");
    // Stagger words on mouse enter.
    button.addEventListener("mouseenter", ()=>{
        gsap.to(buttonEls.words, {
            yPercent: -100,
            stagger: 0.01,
            duration: 0.5,
            ease: "expo.out"
        });
        gsap.to(bg, {
            scaleX: 1,
            duration: 0.5,
            ease: "expo.out"
        });
        if (icon[0].classList.contains("move-horizontal")) gsap.to(icon, {
            xPercent: 100,
            duration: 0.5,
            ease: "expo.out"
        });
        else if (icon[0].classList.contains("move-vertical")) gsap.to(icon, {
            yPercent: 100,
            duration: 0.5,
            ease: "expo.out"
        });
    });
    // Revert animations on mouse leave.
    button.addEventListener("mouseleave", ()=>{
        gsap.to(buttonEls.words, {
            yPercent: 0,
            stagger: 0.02,
            duration: 0.5,
            ease: "expo.out"
        });
        gsap.to(bg, {
            scaleX: 0,
            duration: 0.3,
            ease: "expo.out"
        });
        if (icon[0].classList.contains("move-horizontal")) gsap.to(icon, {
            xPercent: 0,
            duration: 0.3,
            ease: "expo.out"
        });
        else if (icon[0].classList.contains("move-vertical")) gsap.to(icon, {
            yPercent: 0,
            duration: 0.3,
            ease: "expo.out"
        });
    });
}


function $ee20a49b40292314$export$22ea07d0c2ddb570() {
    const menu = document.querySelector(".navbar_component");
    if (!menu) {
        console.error("No menu found.");
        return;
    }
    // use gsap.matchMedia to check if the screen is table or mobile.
    // If it is, add extra logic to open the mobile menu on click and also the dropdowns on click.
    // If it is not, use the mouseenter and mouseleave events to show and hide the dropdowns.
    const mm = gsap.matchMedia();
    mm.add({
        isMobile: "(max-width: 991px)",
        isDesktop: "(min-width: 992px)"
    }, (context)=>{
        const menuItems = menu.querySelectorAll(".navbar_link");
        menuItems.forEach((item)=>$ee20a49b40292314$var$setMenuItem(item, context.conditions.isMobile));
        const dropdowns = menu.querySelectorAll(".navbar_dropdown-trigger");
        if (!dropdowns) {
            console.error("No dropdowns found.");
            return;
        }
        if (context.conditions.isMobile) {
            const menuTrigger = menu.querySelector(".navbar_link.is-mobile-trigger");
            const menuDropdown = menu.querySelector(".navbar_menu");
            const contentWrapper = document.querySelector(".main-wrapper");
            const footer = document.querySelector(".footer_component");
            gsap.set(menuDropdown, {
                height: 0
            });
            menuTrigger.addEventListener("click", ()=>{
                menuDropdown.classList.toggle("is-active");
                if (menuDropdown.classList.contains("is-active")) {
                    gsap.to(menuDropdown, {
                        height: "auto",
                        duration: 0.5,
                        ease: "expo.out"
                    });
                    gsap.to(menuTrigger.querySelectorAll(".navbar_link-icon-svg"), {
                        rotate: 180,
                        duration: 0.5,
                        ease: "expo.out"
                    });
                    gsap.to(contentWrapper, {
                        filter: "blur(15px)",
                        duration: 0.5,
                        ease: "expo.out"
                    });
                    gsap.to(footer, {
                        filter: "blur(15px)",
                        duration: 0.5,
                        ease: "expo.out"
                    });
                } else {
                    gsap.to(menuDropdown, {
                        height: 0,
                        duration: 0.5,
                        ease: "expo.out"
                    });
                    gsap.to(menuTrigger.querySelectorAll(".navbar_link-icon-svg"), {
                        rotate: 0,
                        duration: 0.5,
                        ease: "expo.out"
                    });
                    gsap.to(contentWrapper, {
                        filter: "blur(0px)",
                        duration: 0.5,
                        ease: "expo.out"
                    });
                    gsap.to(footer, {
                        filter: "blur(0px)",
                        duration: 0.5,
                        ease: "expo.out"
                    });
                }
            });
        }
        dropdowns.forEach((dropdown)=>{
            $ee20a49b40292314$var$setDropdown(dropdown, context.conditions.isMobile);
        });
    });
}
function $ee20a49b40292314$var$setMenuItem(item) {
    const itemEls = new SplitType(item.querySelector(".navbar_link-label"), {
        types: "lines, words",
        tagName: "span"
    });
    item.addEventListener("mouseenter", ()=>{
        gsap.to(itemEls.words, {
            yPercent: -100,
            stagger: 0.05,
            duration: 0.5,
            ease: "expo.out"
        });
    });
    item.addEventListener("mouseleave", ()=>{
        gsap.to(itemEls.words, {
            yPercent: 0,
            stagger: 0.05,
            duration: 0.5,
            ease: "expo.out"
        });
    });
}
function $ee20a49b40292314$var$setDropdown(dropdown, isMobile) {
    // add mouse hover logic to show / hide dropdown based on .navbar_dropdown height
    const dropdownMenu = dropdown.querySelector(".navbar_dropdown");
    const dropdownLinks = dropdownMenu.querySelectorAll(".dropdown_item");
    gsap.set(dropdownLinks, {
        yPercent: 50,
        opacity: 0
    });
    const tl = gsap.timeline();
    const openDropdown = ()=>{
        tl.clear();
        tl.set(dropdownMenu, {
            height: "0"
        });
        tl.set(dropdownLinks, {
            yPercent: 50,
            opacity: 0
        });
        tl.to(dropdownMenu, {
            height: "auto",
            duration: 0.5,
            ease: "expo.out"
        });
        tl.to(dropdown.querySelectorAll(".navbar_link-icon-svg"), {
            rotate: 180,
            duration: 0.5,
            ease: "expo.out"
        }, 0);
        tl.to(dropdownLinks, {
            yPercent: 0,
            opacity: 1,
            stagger: 0.01,
            duration: 0.5,
            ease: "expo.out"
        }, 0.25);
    };
    const closeDropdown = ()=>{
        tl.clear();
        tl.to(dropdownMenu, {
            height: 0,
            duration: 0.5,
            ease: "expo.out"
        });
        tl.to(dropdownLinks, {
            yPercent: 50,
            opacity: 0,
            duration: 0.3,
            ease: "expo.out"
        }, 0);
        tl.to(dropdown.querySelectorAll(".navbar_link-icon-svg"), {
            rotate: 0,
            duration: 0.5,
            ease: "expo.out"
        }, 0);
    };
    if (isMobile) dropdown.addEventListener("click", (e)=>{
        e.preventDefault();
        if (dropdown.classList.contains("active")) {
            closeDropdown();
            dropdown.classList.remove("active");
        } else {
            openDropdown();
            dropdown.classList.add("active");
        }
    });
    else {
        dropdown.addEventListener("mouseenter", ()=>{
            openDropdown();
        });
        dropdown.addEventListener("mouseleave", ()=>{
            closeDropdown();
        });
    }
}


function $1c7845f0e1de0887$export$8f060496e19d4bbb(lines, callback) {
    // Wrap each line in a .line-wrapper span
    lines.forEach((line)=>{
        // add a space right after the last word to prevent the line from collapsing
        const innerHTML = line.innerHTML;
        // add space after the last word
        const newInnerHTML = innerHTML.replace(/(\w+)(\s*)$/, '$1 $2');
        line.innerHTML = newInnerHTML;
    });
    if (typeof callback === 'function') callback();
}


// Link timelines to scroll position
function $1aa2e0393d0f1beb$var$createScrollTrigger(triggerElement, elements, start, end, stagger, delay, withScroll) {
    const trigger = {
        trigger: triggerElement,
        scrub: true,
        start: start,
        fastScrollEnd: 500,
        preventOverlaps: "scroll-text"
    };
    if (!withScroll) {
        trigger.onEnter = ()=>{
            gsap.to(elements, {
                y: 0,
                opacity: 1,
                stagger: stagger,
                duration: 1.5,
                ease: "power4.out",
                delay: Number(delay)
            });
        };
        gsap.timeline({
            scrollTrigger: trigger
        });
    } else {
        trigger.end = end;
        gsap.timeline({
            scrollTrigger: trigger
        }).to(words, {
            y: 0,
            opacity: 1.5,
            stagger: stagger,
            duration: 1,
            ease: "none"
        });
    }
}
function $1aa2e0393d0f1beb$export$1601281ad392a6d8() {
    // Split all words on the brand core section
    const textEls = document.querySelectorAll('[stagger-text]');
    textEls.forEach((el)=>{
        const type = el.getAttribute("stagger-text");
        let staggerTextEls;
        if (el.classList.contains('w-richtext')) staggerTextEls = new SplitType(el.querySelectorAll("p, li, h2, h3"), {
            types: type === "words" ? "words" : "lines",
            tagName: "span"
        });
        else staggerTextEls = new SplitType(el, {
            types: type === "words" ? "words" : "lines",
            tagName: "span"
        });
        if (type !== "words") (0, $1c7845f0e1de0887$export$8f060496e19d4bbb)(staggerTextEls.lines);
        gsap.set(type === "words" ? staggerTextEls.words : staggerTextEls.lines, {
            y: "1em",
            opacity: 0
        });
        el.classList.add("init");
        const words1 = type === "words" ? el.querySelectorAll(".word") : el.querySelectorAll(".line"), startVal = el.dataset.startPos || "bottom bottom", endVal = el.dataset.endPos || "bottom center", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0, withScrollTrigger = el.dataset.withScroll || false;
        $1aa2e0393d0f1beb$var$createScrollTrigger(el, words1, startVal, endVal, stagger, delay, withScrollTrigger);
    });
}


// Link timelines to scroll position
function $4013e65a83b1b778$var$createScrollList(triggerElement, elements, start, stagger, delay) {
    gsap.set(elements, {
        yPercent: 100,
        opacity: 0
    });
    gsap.timeline({
        scrollTrigger: {
            trigger: triggerElement,
            scrub: true,
            start: start,
            onEnter: ()=>{
                gsap.to(elements, {
                    yPercent: 0,
                    opacity: 1,
                    stagger: stagger,
                    ease: "power4.out",
                    delay: Number(delay)
                });
            }
        }
    });
}
function $4013e65a83b1b778$export$9b05384e3b3cbff1() {
    const list = document.querySelectorAll("[stagger-list]");
    if (!list) return;
    list.forEach((el)=>{
        const elements = el.querySelectorAll("[stagger-el]"), startVal = el.dataset.startPos || "top bottom", stagger = el.dataset.stagger || 0.05, delay = el.dataset.delay || 0;
        if (!elements) return;
        $4013e65a83b1b778$var$createScrollList(el, elements, startVal, stagger, delay);
    });
}


function $2739916fb78fd945$export$e125e88f659d8ab1() {
    const paths = document.querySelectorAll("[path-reveal]");
    if (!paths) {
        console.error("No paths found.");
        return;
    }
    paths.forEach((path)=>{
        $2739916fb78fd945$var$setPathAnimation(path);
    });
}
function $2739916fb78fd945$var$setPathAnimation(path) {
    // use GSAP drawSVG plugin to animate path drawing  
    const pathEls = path.querySelectorAll("path");
    const duration = path.dataset.duration ? parseFloat(path.dataset.duration) : 3;
    gsap.set(pathEls, {
        drawSVG: "0%"
    });
    // Set ScrollTrigger to trigger animation when path is in view
    ScrollTrigger.create({
        trigger: path,
        start: "top center",
        onEnter: ()=>{
            gsap.to(pathEls, {
                drawSVG: "100%",
                duration: duration,
                ease: "expo.out"
            });
        }
    });
}


function $0cbe32f8563a9a71$export$3e5ce0c0ac78a8da() {
    // Get detection offset, in this case the navbar
    const navBarHeight = document.querySelector("[data-nav-bar-height]");
    const themeObserverOffset = navBarHeight ? navBarHeight.offsetHeight / 2 : 0;
    function checkThemeSection() {
        const themeSections = document.querySelectorAll("[data-theme-section]");
        themeSections.forEach(function(themeSection) {
            const rect = themeSection.getBoundingClientRect();
            const themeSectionTop = rect.top;
            const themeSectionBottom = rect.bottom;
            // If the offset is between the top & bottom of the current section
            if (themeSectionTop <= themeObserverOffset && themeSectionBottom >= themeObserverOffset) {
                // Check [data-theme-section]
                const themeSectionActive = themeSection.getAttribute("data-theme-section");
                document.querySelectorAll("[data-theme-nav]").forEach(function(elem) {
                    if (elem.getAttribute("data-theme-nav") !== themeSectionActive) elem.setAttribute("data-theme-nav", themeSectionActive);
                });
                // Check [data-bg-section]
                const bgSectionActive = themeSection.getAttribute("data-bg-section");
                document.querySelectorAll("[data-bg-nav]").forEach(function(elem) {
                    if (elem.getAttribute("data-bg-nav") !== bgSectionActive) elem.setAttribute("data-bg-nav", bgSectionActive);
                });
            }
        });
    }
    function startThemeCheck() {
        document.addEventListener("scroll", checkThemeSection);
    }
    // Initial check and start listening for scroll
    checkThemeSection();
    startThemeCheck();
}


function $b140b9eb34f1ac44$export$4bc49541bd3cd0fc() {
    const forms = document.querySelectorAll("form");
    if (!forms) return;
    forms.forEach((form)=>{
        const formSubmitButton = form.querySelector(".button.is-submit");
        const submitButton = form.querySelector(".form_submit");
        const label = form.querySelector(".button_label");
        if (!formSubmitButton || !submitButton) return;
        // add event listener to the form submit button
        formSubmitButton.addEventListener("click", function(e) {
            e.preventDefault(); // prevent the default action
            // check if the form is valid
            if (form.checkValidity()) {
                // if valid, submit the form and change the button text
                submitButton.click();
                label.textContent = submitButton.getAttribute("data-wait");
            } else // if not valid, report validity (this will show the HTML5 validation messages)
            form.reportValidity();
        });
    // form.addEventListener("submit", function () {
    //   // scroll screen back to the top of the using Lenis.js scrollTo method
    //   const formTop = form.getBoundingClientRect().top;
    //   lenis.scrollTo(formTop, 500);
    // });
    });
}


function $7d54ea0d6e840462$export$d5bd5b80f649d6c() {
    const wrapper = document.querySelector(".contact-modal");
    // const form = wrapper.querySelector("form");
    if (!wrapper) return;
    const backdrop = wrapper.querySelector(".contact-modal_backdrop");
    const body = wrapper.querySelector(".contact-modal_body");
    const closeButton = wrapper.querySelector(".contact-modal_close");
    gsap.set(wrapper, {
        display: "none"
    });
    gsap.set(backdrop, {
        autoAlpha: 0
    });
    gsap.set(body, {
        clipPath: "inset(50%)"
    });
    gsap.set(closeButton, {
        scale: 0
    });
    const tl = gsap.timeline({
        paused: true
    });
    tl.set(wrapper, {
        display: "flex"
    });
    tl.to(backdrop, {
        autoAlpha: 1,
        duration: 0.5,
        ease: "expo.inOut"
    });
    tl.to(body, {
        clipPath: "inset(0%)",
        duration: 1,
        ease: "expo.inOut"
    }, 0.25);
    tl.to(closeButton, {
        scale: 1,
        duration: 0.5,
        ease: "expo.inOut"
    }, 1);
    const openButton = document.querySelectorAll("[data-contact-trigger]");
    openButton.forEach((button)=>{
        button.addEventListener("click", ()=>{
            wrapper.classList.add("is-active");
            // document.body.classList.add("no-scrollbar");
            lenis.stop();
            tl.play();
        });
    });
    closeButton.addEventListener("click", ()=>{
        wrapper.classList.remove("is-active");
        // document.body.classList.remove("no-scrollbar");
        lenis.start();
        tl.reverse();
    });
    $7d54ea0d6e840462$var$setCheckBoxes();
}
function $7d54ea0d6e840462$var$setCheckBoxes() {
    // get list of custom checkboxes groups on the page
    const groups = document.querySelectorAll(".input_checkbox-group");
    // loop through each group
    groups.forEach((group)=>{
        // get all checkboxes in the group
        const checkboxes = group.querySelectorAll("input[type='checkbox']");
        // identify the hidden text field inside each group
        const hiddenInput = group.querySelector(".input_checkbox-hidden");
        if (!checkboxes.length) return;
        //when any checkbox on this group change, grab the values, transform the array into a string, and update the hidden field
        function updateHiddenInput() {
            const values = Array.from(checkboxes).filter((checkbox)=>checkbox.checked).map((checkbox)=>checkbox.value);
            hiddenInput.value = values.join(", ");
        }
        // loop through each checkbox
        checkboxes.forEach((checkbox)=>{
            // get checkbox label
            const label = checkbox.nextElementSibling;
            // set checkbox value to label text
            checkbox.value = label.textContent;
            // when checkbox change, update the hidden input
            checkbox.addEventListener("change", updateHiddenInput);
        });
    });
}


window.addEventListener("beforeunload", ()=>{
    // console.log("beforeunload");
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
window.addEventListener("popstate", ()=>{
    // console.log("popstate");
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
document.addEventListener("pageshow", (event)=>{
    // console.log("pageshow", event);
    // Check if the page was restored from the bfcache
    if (event.persisted) // Re-run your loading animation
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
});
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $ce6a18b12420bce7$export$7fd17f34fe72f4b0)();
    (0, $0cbe32f8563a9a71$export$3e5ce0c0ac78a8da)();
    (0, $8dde7174b81b4982$export$1744cb1794fd120a)();
    (0, $ee20a49b40292314$export$22ea07d0c2ddb570)();
    (0, $1aa2e0393d0f1beb$export$1601281ad392a6d8)();
    (0, $4013e65a83b1b778$export$9b05384e3b3cbff1)();
    (0, $2739916fb78fd945$export$e125e88f659d8ab1)();
    (0, $b140b9eb34f1ac44$export$4bc49541bd3cd0fc)();
    (0, $7d54ea0d6e840462$export$d5bd5b80f649d6c)();
});

})();
//# sourceMappingURL=globals.js.map
